import { useJsApiLoader } from '@react-google-maps/api';

// Define libraries array outside component to prevent recreation on each render
// This is important to avoid the "LoadScript has been reloaded" warning
const libraries = ['places'];

const useGoogleMaps = () => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_REACT_GOOGLE_MAP_KEY || '',
    libraries,
  });

  return { isLoaded, loadError };
};

export default useGoogleMaps;
